import { Button } from 'antd'

import { useArrayField } from '../../hooks/useArrayField'

import { AddButtonProps } from './interface'

export const AddButton = ({
  type = 'link',
  children = '添加',
  ...restProps
}: AddButtonProps) => {
  const field = useArrayField()

  const handleClick = () => {
    field.push({})
  }

  return (
    <Button type='link' {...restProps} onClick={handleClick}>
      {children}
    </Button>
  )
}
